import React, { useState,useEffect } from "react";
import { Link } from "react-router-dom";
import Header from "../layouts/Header";
import Sidebar from "../layouts/Sidebar";
import "../_components/antd.css";
import { Table, Tooltip } from "antd";
//import Data from "../assets/jsons/customers";
import { useAuth } from "../context/AuthContext";
import { useHistory,useParams } from "react-router-dom";
import api from "../api/api"
import ApplicationExternalForm from "../forms-pdf/ApplicationExternalForm";
import CSafetyAgreementFormFDWEmployer from "../forms-pdf/CSafetyAgreementFormFDWEmployer";
import ESafetyAgreementFormFDWEmployer from "../forms-pdf/ESafetyAgreementFormFDWEmployer";
import FSafetyAgreementFormFDWEmployer from "../forms-pdf/FSafetyAgreementFormFDWEmployer";
import JobOffer from "../forms-pdf/JobOffer";
import StandardEmploymentContract from "../forms-pdf/StandardEmploymentContract";
import EmployerIncomeTaxDeclaration from "../forms-pdf/EmployerIncomeTaxDeclaration";
import AuthorisationEAFdw from "../forms-pdf/AuthorisationEAFdw";
import FdwRestDayAgreement from "../forms-pdf/FdwRestDayAgreement";
import FilipinoEmploymentContract from "../forms-pdf/FilipinoEmploymentContract";
import EmployerFdwInterview from "../forms-pdf/EmployerFdwInterview";
import DeclarationIncomeForm from "../forms-pdf/DeclarationIncomeForm";
const ExternalForms = () => {
    const {user} = useAuth();
    const history = useHistory();
    const { id:idBiodata , booking_id } = useParams();
    useEffect(() => {
        if(!idBiodata || !booking_id ){
            history.push('/booking');
        }
    }, [idBiodata, booking_id]);
    const [menu, setMenu] = useState(false);
    const [selectedForm, setSelectedForm] = useState('job-offer');

    const toggleMobileMenu = () => {
        setMenu(!menu);
    };

    const formItems = [
       { 
            id: 'job-offer', 
            title: 'Job Offer' 
        },
        {
            id: 'application-form',
            title: 'Application Form'
        },
        {
            id: 'authorization-ea-fdw',
            title: 'Authorisation for EA for FDW'
        },
        {
            id: 'declaration-income',
            title: 'Declaration Income Form'
        },
        { 
            id: 'employer-income-tax', 
            title: 'Employer Income Tax Declaration' 
        },
        { 
            id: 'standard-employment-contract', 
            title: 'Standard Employment Contract' 
        },
        {
            id: 'fdw-employer-weekly-rest-day-agreement',
            title: 'FDW & Employer Weekly Rest Day Agreement'
        },
        {
            id: 'employer-personal-interview-of-fdw',
            title: 'Employer Personal Interview of FDW'
        },
        {
            id: 'filipino-employment-contract',
            title: 'Filipino Employment Contract'
        },
        { 
            id: 'safety-agreement-burmese', 
            title: 'Annex E - Safety Agreement Form between FDW and Employer (Burmese)' 
        },
        { 
            id: 'safety-agreement-tagalog', 
            title: 'Annex C - Safety Agreement Form between FDW and Employer (Tagalog)' 
        },
        { 
            id: 'safety-agreement-bahasa', 
            title: 'Annex F - Safety Agreement Form between FDW and Employer (Bahasa Indonesia)' 
        }
    ];

    const renderContent = () => {
        const selectedItem = formItems.find(item => item.id === selectedForm);
        const ContentIs = () => {
             switch(selectedForm) {
                        case 'job-offer':
                            return <JobOffer idBiodata={idBiodata} booking_id={booking_id} />;
                        case 'application-form':
                            return <ApplicationExternalForm idBiodata={idBiodata} booking_id={booking_id} />;
                        case 'authorization-ea-fdw':
                            return <AuthorisationEAFdw idBiodata={idBiodata} booking_id={booking_id} />;
                        case 'declaration-income':
                            return <DeclarationIncomeForm idBiodata={idBiodata} booking_id={booking_id} />;
                        case 'fdw-employer-weekly-rest-day-agreement':
                            return <FdwRestDayAgreement idBiodata={idBiodata} booking_id={booking_id} />;
                        case 'filipino-employment-contract':
                            return <FilipinoEmploymentContract idBiodata={idBiodata} booking_id={booking_id} />;
                        case 'employer-personal-interview-of-fdw':
                            return <EmployerFdwInterview idBiodata={idBiodata} booking_id={booking_id} />;
                        case 'employer-income-tax':
                            return <EmployerIncomeTaxDeclaration idBiodata={idBiodata} booking_id={booking_id} />;
                        case 'standard-employment-contract':
                            return <StandardEmploymentContract idBiodata={idBiodata} booking_id={booking_id} />;
                        case 'safety-agreement-burmese':
                            return <ESafetyAgreementFormFDWEmployer idBiodata={idBiodata} booking_id={booking_id} />;
                        case 'safety-agreement-tagalog':
                            return <CSafetyAgreementFormFDWEmployer idBiodata={idBiodata} booking_id={booking_id} />;
                        case 'safety-agreement-bahasa':
                            return <FSafetyAgreementFormFDWEmployer idBiodata={idBiodata} booking_id={booking_id} />;
                        default:
                            return <p style={{ fontSize: '16px', lineHeight: '1.6', color: '#666' }}>
                                This is the content for {selectedItem?.title}.
                                Please select a form from the left to view its details.
                            </p>;
                    }
        }
        return (
            <div className="content-area">
                <h2 style={{ marginBottom: '20px', color: '#333' }}>
                    {selectedItem?.title}
                </h2>
                
                   <ContentIs />
                
            </div>
        );
    };

  
    //const datasource = Data?.Data;



    return (
        <>
            <div className={`main-wrapper ${menu ? "slide-nav" : ""}`}>
                <Header onMenuClick={() => toggleMobileMenu()} />
                <Sidebar />
                <div className="page-wrapper">
                    <div style={{ display: 'flex', height: '100vh' }}>
                        {/* Sidebar */}
                        <div style={{ 
                            width: '350px', 
                            backgroundColor: '#f8f9fa', 
                            borderRight: '1px solid #dee2e6',
                            padding: '20px',
                             overflowY: 'auto'
                        }}>
                            <h3 style={{ 
                                marginBottom: '20px', 
                                color: '#495057',
                                borderBottom: '2px solid #007bff',
                                paddingBottom: '10px'
                            }}>
                                Contracts and Aggreements
                            </h3>
                            <div style={{ display: 'flex', flexDirection: 'column', gap: '10px' }}>
                                {formItems.map((item) => (
                                    <button
                                        key={item.id}
                                        onClick={() => setSelectedForm(item.id)}
                                        style={{
                                            padding: '12px 16px',
                                            border: selectedForm === item.id ? '2px solid #007bff' : '1px solid #dee2e6',
                                            backgroundColor: selectedForm === item.id ? '#e3f2fd' : '#ffffff',
                                            color: selectedForm === item.id ? '#1976d2' : '#495057',
                                            cursor: 'pointer',
                                            borderRadius: '8px',
                                            textAlign: 'left',
                                            fontSize: '14px',
                                            lineHeight: '1.4',
                                            transition: 'all 0.2s ease',
                                            fontWeight: selectedForm === item.id ? '600' : '400'
                                        }}
                                        onMouseEnter={(e) => {
                                            if (selectedForm !== item.id) {
                                                e.target.style.backgroundColor = '#f8f9fa';
                                                e.target.style.borderColor = '#adb5bd';
                                            }
                                        }}
                                        onMouseLeave={(e) => {
                                            if (selectedForm !== item.id) {
                                                e.target.style.backgroundColor = '#ffffff';
                                                e.target.style.borderColor = '#dee2e6';
                                            }
                                        }}
                                    >
                                        {item.title}
                                    </button>
                                ))}
                            </div>
                        </div>

                        {/* Content Area */}
                        <div style={{ 
                            flex: 1, 
                            padding: '30px',
                            backgroundColor: '#ffffff',
                           // overflowY: 'auto'
                        }}>
                            {renderContent()}
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
};

export default ExternalForms;
